import { isDefaultLanguage } from './helpers';

const formatDateForPressLink = (date, locale) => {
  const dateObj = new Date(date);

  if (!locale || isDefaultLanguage(locale)) {
    const shortenedMonthName = dateObj.toLocaleString(locale, {
      month: 'short',
    });
    const dayOfMonth = dateObj.getDate();
    return `${shortenedMonthName}.${dayOfMonth}`;
  }

  return dateObj.toLocaleString(locale, {
    month: 'short',
    day: 'numeric',
  });
};

export default formatDateForPressLink;
